/**
 * Defines global functions which are used to display toast notifications.
 * Most of these functions simply forward the message to the notificationService
 * The DoShowError function however "parses" the HttpResponse and selects an appropriate message
 * 
 * In time we should try to move these into a service.
 * This could be the notificationService although this service has the benefit of wrapping the external
 * PNotify dependency. It would be useful to make that the single responsibility of the notificationService.
 * This means we want to write another service which acts as the interface.
 * This can also handle the "parsing" although there are (probably) better options. These do however
 * require significant work on the API side.
 */
(function (w) {
    "use strict";

    // TODO: this needs to be improved
    w.DoShowError = parseErrorFromResultAndShow;

    w.CheckResultReceived = function (response) {
        // A response exists but the data is not set
        if (response && !response.data) {
            return true;
        }
        // A response exists but the status is not 200 (OK) and the data is a string, or contains a message or is an empty array buffer
        else if (response && response.status !== 200 && (isString(response.data) || response.data.Message || (isArrayBuffer(response.data) && response.data.byteLength === 0))) {
            return false;
        }
        else {
            return true;
        }
    };

    function parseErrorFromResultAndShow(notificationService, result) {
        if (result === null)
            return;

        const message = getErrorFromResult(result);

        notificationService.error(message);
    }

    function isString(value) {
        return typeof value === 'string' || value instanceof String;
    }

    function isArrayBuffer(value) {
        return value instanceof ArrayBuffer;
    }

    function decodeArrayBuffer(buffer) {
        const decoder = new TextDecoder();
        return {
            data: JSON.parse(decoder.decode(buffer))
        };
    }

    // TODO-1: A lot of this logic is probably outdated investigate which checks can be ignored
    // TODO-2: This transformation should be done using angular interceptors
    function getErrorFromResult(result) {

        if (isString(result)) {
            return result;
        }
        else if (isArrayBuffer(result.data)) {
            try {
                return decodeArrayBuffer(result.data);
            }
            catch {
                return GetServerError();
            }
        }
        else if (result.status === 0) {
            return GetServerError();
        }
        else if (result.status >= 500 && result.status <= 599) {
            if (result.data !== undefined) {
                if (result.data.ExceptionMessage !== undefined) {
                    return result.data.ExceptionMessage;
                }
                else if (result.data.Error) {
                    return result.data.Error;
                }
                else if (result.data.Message) {
                    return result.data.Message;
                }
                else {
                    return result.data;
                }
            }
            else if (result.statusText !== undefined) {
                return GetServerErrorTranslated(result.statusText);
            }
            else {
                return GetServerError();
            }
        }
        else if (result.status >= 300 && result.status <= 399) {
            return GetReloginError();
        }
        // Direct messages
        else if (result.Message !== undefined) {
            return result.Message;
        }
        else if (result.data === undefined) {
            return GetServerError();
        }
        else if (isString(result.data)) {
            if ((result.data.indexOf('/login.js"') > 0 || result.data.indexOf('/Account/Login') > 0)) {
                return GetReloginError();
            }
            else if (result.data.indexOf(" ") > 0) {
                return result.data;
            }
            else if (result.data.indexOf('<title>') > 0) {
                const message = result.data.substring(result.data.indexOf('<title>') + 7, result.data.indexOf('</title>'));
                return message;
            }
            else {
                return GetServerErrorTranslated(result.data);
            }
        }
        else if (result.data.ExceptionMessage !== undefined) {
            return result.data.ExceptionMessage;
        }
        else if (result.data.Message !== undefined) {
            return result.data.Message;
        }
        else if (result.data.MessageDetail !== undefined) {
            return result.data.MessageDetail;
        }
        else if (result.statusText !== undefined) {
            return GetServerErrorTranslated(result.statusText);
        }
        else if (result.ExceptionMessage !== undefined) {
            return result.ExceptionMessage;
        }
        else if (result.statusText === undefined) {
            return GetServerError();
        }
        else {
            return result.data;
        }
    }
})(window);
